<mat-toolbar>
  <button class="go-back-btn" mat-icon-button (click)="goBack()">
    <mat-icon>arrow_back_ios</mat-icon>
  </button>
  @if (projectSummary(); as projectSummary) {
    <span>Analysis Dashboard - {{ projectSummary.name }}</span>
  } @else {
    <span>Analysis Dashboard</span>
  }
</mat-toolbar>

<div class="container">

  @if (loading()) {
    <app-loading-card title="Loading your summaries...">
      <p>insights, taming wild data points, and convincing AI to share its wisdom. Your summaries are almost ready!</p>
    </app-loading-card>
  } @else {


    @if (!found()) {
      <app-error-card
      >
        <div>
          <p>This analysis could not be found!</p>
          <p>Either it doesn't exist or you don't have permission to access it.</p>
        </div>
      </app-error-card>

    } @else {
      <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" (selectedIndexChange)="indexChange($event)">
        <mat-tab label="Complete summary">
          @if (projectSummary(); as projectSummary) {
            @if (projectSummary.summary) {
            <markdown [data]="projectSummary.summary"></markdown>
            } @else {
              <app-loading-card
                title="Creating your summary">
                <p>Analyzing your document and creating meaningful summary ...</p>
              </app-loading-card>
            }
          } @else {
            <app-loading-card
              title="Creating your summary">
              <p>Analyzing your document and creating meaningful summary ...</p>
            </app-loading-card>
          }
        </mat-tab>
        <mat-tab label="Individual paper summary">
          @if (papersSummary().length > 0) {
            <app-research-paper-list
              [projectId]="projectId()"
              [papersFilter]="getPapersIds()"
              [linkSelectedTab]="2"
              [filters]="papersFilter"
            ></app-research-paper-list>
          } @else {
            No papers summary found
          }
        </mat-tab>
        <mat-tab label="Chat">
          @defer (when selectedTabIndex() == 2) {
            @if (projectSummary(); as projectSummary) {
              <app-summary-chat-window class="chat-window" [projectId]="projectSummary.projectId"
                                       [summaryId]="projectSummary.id"></app-summary-chat-window>
            }
          }
        </mat-tab>
      </mat-tab-group>

    }
  }

</div>
